import { GamePlanEntity, TodoItemEntity, TodoItemStatus } from "./typings";
import * as _ from "lodash";

/**
 * Advance the given status to the next one
 * @param status
 * @example
 * ```ts
 * advanceTaskStatus(0); // 1
 * advanceTaskStatus(1); // 0
 * ```
 */
export const advanceTaskStatus = (status: TodoItemStatus): TodoItemStatus => {
  if (status === TodoItemStatus.ToDo) {
    return TodoItemStatus.Completed;
  }

  return TodoItemStatus.ToDo;
};

/**
 * Tell if the given entity is a game plan
 * @param e
 * @return {e is GamePlanEntity}
 */
export function isGamePlan(e: unknown): e is GamePlanEntity {
  return _.isArray((e as GamePlanEntity).taskList);
}

/**
 * Tell if the given entity is a game plan task
 * @param e
 * @return {e is TodoItemEntity}
 */
export function isTask(e: unknown): e is TodoItemEntity {
  return (e as TodoItemEntity).hasOwnProperty("createdBy");
}
